import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../shared/services/auth-service/auth.service';

@Component({ template: '' })
export class AuthCallbackComponent implements OnInit {
  constructor(private readonly _authService: AuthService) {}
  async ngOnInit() {
    await this._authService.handleRedirectAfterLogin();
  }
}
